import { CogTransferOutlineIcon } from './CogTransferOutlineIcon';

/**
 * author: Michael Richins
 * id AD008794-9094-40B5-91E8-6648E1CBADAD
 * name cog-transfer-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-transfer-outline.svg
 * tags
 * - Settings 
 */
export const SettingsTransferOutlineIcon = CogTransferOutlineIcon;
export default SettingsTransferOutlineIcon